// src/hooks/useBranding.js
import { useState, useEffect, useCallback } from "react";
import { doc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const DEFAULT_COLOR = "#2B6CB0";

const EMPTY = {
  productName: null,
  logoUrl: null,
  primaryColor: null,
  footerText: null,
};

export function useBranding(orgId) {
  const [branding, setBranding] = useState(EMPTY);

  useEffect(() => {
    if (!orgId) return;
    const unsub = onSnapshot(
      doc(db, "organizations", orgId, "branding", "settings"),
      (snap) => setBranding({ ...EMPTY, ...(snap.exists() ? snap.data() : {}) })
    );
    return unsub;
  }, [orgId]);

  // Apply primary color to CSS custom properties whenever it changes
  useEffect(() => {
    const color = branding.primaryColor || DEFAULT_COLOR;
    document.documentElement.style.setProperty("--accent", color);
    document.documentElement.style.setProperty("--pp-blue", color);
  }, [branding.primaryColor]);

  const updateBranding = useCallback(async (updates, updatedBy) => {
    await setDoc(
      doc(db, "organizations", orgId, "branding", "settings"),
      { ...updates, updatedAt: serverTimestamp(), updatedBy: updatedBy || null },
      { merge: true }
    );
  }, [orgId]);

  return { branding, updateBranding };
}
